import { render, staticRenderFns } from "./mlc.vue?vue&type=template&id=189b3429&scoped=true&"
import script from "./mlc.vue?vue&type=script&lang=js&"
export * from "./mlc.vue?vue&type=script&lang=js&"
import style0 from "./mlc.vue?vue&type=style&index=0&id=189b3429&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b3429",
  null
  
)

export default component.exports